module.exports = __webpack_public_path__ + "img/logo.195e8ea7.svg";